export default {
  buttons: {
    back: "Back",
    next: "Next",
  },
};
